import React, { useState } from "react";
import { Link } from "react-router-dom";
const ItemsMenu = ({ token, username }) => {
  const [isActive, setIsActive] = useState(false);
  if (username.bedrijf && username.bedrijf.modules.includes("cms")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      return (
        <li className="treeview">
          <a className="cursurhand" onClick={() => setIsActive(!isActive)}>
            <i className="fa fa-window-restore" />
            <span>CMS</span>
            <span className="pull-right-container">
              <i className="fa fa-angle-left pull-right" />
            </span>
          </a>
          <ul className={isActive ? "treeview-menu menu-open" : "treeview-menu "}>
            <li>
              <Link to="/cms/content" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" />
                <span>Content manager</span>
              </Link>
            </li>
            <li>
              <Link to="/cms/berichten" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" />
                <span>Berichten</span>
              </Link>
            </li>
            <li>
              <Link to="/cms/types" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" /> <span>Content Type Builder</span>
              </Link>
            </li>
            <li>
              <Link to="/cms/media" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" /> <span>Media bestanden</span>
              </Link>
            </li>
            <li>
              <Link to="/cms/settings" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" /> <span>Settings</span>
              </Link>
            </li>
          </ul>
        </li>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default ItemsMenu;
